module.exports = "/fonts/ElevanceSans-Regular.2c925a5766e519b3d5983a6298332f08.eot";